import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Flex } from "@similarweb/ui-components/foundations";

export const NoTouchPurchaseSummaryModalTitleContainer = styled(Flex)`
    justify-content: space-between;
    align-items: center;
    height: 72px;
    padding: 0 24px;
    border-bottom: 1px solid ${colorsPalettes.carbon[50]};
`;
